import * as query from '@/queries/customer'
import store from '@/store'
import common from '@/utils/common'

const defaultState = function () {
  return {
    storePath: 'Customer',
    mode: 0,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    sizeForDetail: 10,
    rankList: [],
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'customer_list',
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getCustomerRank: async function (reGet = false) {
    if (store.state.Customer.rankList.length === 0 || reGet) {
      const result = await common.postGraphQl(query.GRAPH_QL_QUERY_RANK_LIST)
      store.dispatch({
        type: 'set',
        states: {
          'Customer/rankList': result.data.data.customerRanks
        }
      })
    }

    const options = []
    if (store.state.Customer.rankList) {
      store.state.Customer.rankList.forEach((rank) => {
        options.push({
          code: rank.customerGroup.code + ',' + rank.code,
          name: rank.customerGroup.code + ': ' + rank.name
        })
      })
    }

    store.dispatch({
      type: 'set',
      states: {
        'Customer/searchConditions/customerType/options': options
      }
    })
  },
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/customer.js